import { lazier } from '@shared/components';

export const UnitPaymentLogsPage = lazier(() =>
  import('./UnitPaymentLogsPage'),
);
export const UserPaymentLogsPage = lazier(() =>
  import('./UserPaymentLogsPage'),
);

export { default as PaymentLogWidget } from './PaymentLogWidget';
